import { useSavingsSummaryStyles } from './SavingsSummary.styles';
import { useCart } from '../../../../contexts/CartContext/CartContext.hooks';
import SummaryCardSection from '../SummaryCard.section';
import { useEffect, useState } from 'react';
import { ICostSummaryItem } from '../../../../contexts/CartContext/CartContext.types';
import HorizontalLine from '../../../../components/core/HorizontalLine/HorizontalLine';

const SavingsSummary = () => {
    const styles = useSavingsSummaryStyles();

    const { cart } = useCart();

    const [monthlySummary, setMonthlySummary] = useState<ICostSummaryItem[]>();

    const [dueTodaySummary, setDueTodaySummary] = useState<ICostSummaryItem[]>();

    useEffect(() => {
        if (cart.dueTodaySummary) {
            const todayCosts = cart.dueTodaySummary.filter((t) => t.type === 'discount');
            setDueTodaySummary(todayCosts);
        }
    }, [cart.dueTodaySummary]);

    useEffect(() => {
        if (cart.monthlySummary) {
            const monthlyCosts = cart.monthlySummary.filter((m) => m.type === 'discount');
            setMonthlySummary(monthlyCosts);
        }
    }, [cart.monthlySummary]);

    return (
        <div className={styles.root}>
            <div className={styles.contentWrapper}>
                <div className={styles.title}>Total Estimated Savings</div>

                <HorizontalLine className={styles.lineBreak} />

                <SummaryCardSection
                    title='Monthly Summary'
                    rows={monthlySummary ?? []}
                    totalText='Monthly Savings'
                />

                <HorizontalLine className={styles.lineBreak} />

                <SummaryCardSection
                    title="Today's Summary"
                    rows={dueTodaySummary ?? []}
                    totalText='Savings Today'
                />
            </div>
        </div>
    );
};

export default SavingsSummary;
